/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AdminPatientChatModal.vue?vue&type=template&id=1f46f5b4"
import script from "./AdminPatientChatModal.vue?vue&type=script&lang=js"
export * from "./AdminPatientChatModal.vue?vue&type=script&lang=js"
import style0 from "./AdminPatientChatModal.vue?vue&type=style&index=0&id=1f46f5b4&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f46f5b4')) {
      api.createRecord('1f46f5b4', component.options)
    } else {
      api.reload('1f46f5b4', component.options)
    }
    module.hot.accept("./AdminPatientChatModal.vue?vue&type=template&id=1f46f5b4", function () {
      api.rerender('1f46f5b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/AdminPatientChatModal.vue"
export default component.exports